import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { DocTemplate } from '../../models/doc-template';

import { BackendBaseService } from '../backend-base.service';
import { HttpClientService } from '../common/http-client.service';

@Injectable()
export class DocTemplateService extends BackendBaseService {
  /**
   * [url description]
   *
   * @var  {string}
   */
  url: string = 'doc_templates';

  constructor(public httpClient: HttpClientService) {
    super(httpClient);
  }

  /**
   * Search for document type
   *
   * @param   {string}           term       Term to search
   * @param   {any}              matter_id  To limit by matter
   *
   * @return  {Observable<any>}             Server response JSON
   */
  fieldSearchDocumentType(term: string, matter_id: any): Observable<any> {
    return this.httpClient
      .getObservable(`${this.url}/field_search.json`, {
        array: true,
        matter_id: matter_id,
        term: term,
        template: true,
      })
      .pipe(map((response) => response as any));
  }

  /**
   * New template attributes for template and parts
   * @return {Promise<any>} Server response for new page attributes
   */
  newTemplate(): Promise<any> {
    return this.httpClient.get(`${this.url}/new.json`);
  }

  /**
   * Save doc template
   * @param  {DocTemplate}  docTemplate Doc template to save
   * @return {Promise<any>}             Server response
   */
  save(docTemplate: DocTemplate): Promise<any> {
    return super.save({
      id: docTemplate.id,
      doc_template: docTemplate
    });
  }

  /**
   * Save stylesheets for doc templates
   *
   * @param   {number}         id:             Id of doc template
   * @param   {Arrray<number>} stylesheetIds:  Array of stylesheet ids for the stylesheets to save
   *
   * @return  {Promise<any>}            Server response
   */
  saveStylesheets(id: number, stylesheetIds: Array<number>): Promise<any> {
    return this.httpClient.put(`${this.url}/${id}.json`, { stylesheet_ids: stylesheetIds, stylesheets_save: true });
  }

  /**
   * Deep-clone a template, including all of its doc_parts.
   *
   * @param   {number}  id    Source template id
   * @param   {string}  name  Name for the new template
   * @return  {Promise<any>}  { success, text, doc_template_id }
   */
  clone(id: number, name: string): Promise<any> {
    return this.httpClient.post(`${this.url}/${id}/clone.json`, { name: name });
  }
}
